import sample_1 from './100_19106.jpg';

export const basicsAirImpressions = {
    sample_1,
};
